export default __webpack_public_path__ + "static/media/icon-check.83c38a48.svg";